import { render, staticRenderFns } from "./IngestingTable.vue?vue&type=template&id=9ac4b306&scoped=true"
import script from "./IngestingTable.vue?vue&type=script&lang=js"
export * from "./IngestingTable.vue?vue&type=script&lang=js"
import style0 from "./IngestingTable.vue?vue&type=style&index=0&id=9ac4b306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac4b306",
  null
  
)

export default component.exports